import { render } from "./PrefectureBrowseItem.vue?vue&type=template&id=5486558c"
import script from "./PrefectureBrowseItem.vue?vue&type=script&lang=js"
export * from "./PrefectureBrowseItem.vue?vue&type=script&lang=js"
script.render = render

export default script